class data {

    constructor(data) {
        this.data = data;
    }

    do_query(query_function = false, inventory = false) {
        if (!query_function) {
            this.filtered_data = this.data;
        } else {
            this.filtered_data = this.data.filter(query_function);
        }
        if (inventory) {
            this.do_inventory();
            return this.inventory;
        }

        return this.filtered_data;
    }
    do_inventory() {
        var obj;
        this.inventory = {};
        for (var i = 0; i < this.filtered_data.length; i++) {
            obj = this.filtered_data[i];
            for (const [key, value] of Object.entries(obj)) {
                if (typeof (this.inventory[key]) === 'undefined') {
                    this.inventory[key] = [];
                }

                this.inventory[key].push(value);
            }
        }

        for (const [key, value] of Object.entries(this.inventory)) {
            this.inventory[key + '_unique'] = Array.from(new Set(this.inventory[key])).sort((a, b) => a - b);
        }
    }
}